import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from '@storable/canaveral-components';
import { Link } from 'react-router';
import gql from 'graphql-tag';
import LocalePill from '../LocalePill';

const propTypes = {
  locale: PropTypes.shape({
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {};

const NavigationLocalesMenuItem = ({
  locale,
}) => {
  const { code } = locale;
  const destinationUrl = `/admin/locales/${code}/navigation/edit`;

  return (
    <Menu.Item
      componentClass={Link}
      to={destinationUrl}
    >
      <LocalePill locale={locale} showName />
    </Menu.Item>
  );
};

NavigationLocalesMenuItem.propTypes = propTypes;
NavigationLocalesMenuItem.defaultProps = defaultProps;

NavigationLocalesMenuItem.fragments = {
  locale: gql`
  fragment NavigationLocalesMenuItemLocale on Locale {
    code
    name
    ...LocalePillLocale
  }

  ${LocalePill.fragments.locale}
  `,
};

export default NavigationLocalesMenuItem;
